import { withNamespace } from "@/i18n/lazy-route"

/** The content pages (DV-158): the public reading screen and the admin editor, with the `pages` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/pages.json"),
  fr: () => import("@/i18n/locales/fr/pages.json"),
}

export const PageScreen = withNamespace<{ slug: string }>(
  "pages",
  () => import("./screens/PageScreen"),
  translations,
)
export const AdminPagesScreen = withNamespace(
  "pages",
  () => import("./screens/AdminPagesScreen"),
  translations,
)
export const AdminPageScreen = withNamespace(
  "pages",
  () => import("./screens/AdminPageScreen"),
  translations,
)
export { PUBLIC_PAGES, pageOf } from "./registry"
